import React, { createContext, useContext, useRef, useEffect } from 'react';
import { t } from 'i18next';
import { copyToClipboard } from '../utils/clipboard-utils';

const ClipboardContext = createContext();

export const useClipboard = () => useContext(ClipboardContext);

const AUTO_CLEAR_MS = 10000;

export const ClipboardProvider = ({ children }) => {
    // Biriken değerler yalnızca kopyalama anında okunuyor, hiçbir yerde render edilmiyor →
    // state yerine ref. Böylece her sağ tıkta tüm uygulama ağacı yeniden render olmuyor ve
    // kopyalama işi render fazının tamamen dışında kalıyor.
    const textsRef = useRef([]);
    const timerRef = useRef(null);

    // Clear the accumulated selection if no new pick happens within 10s.
    const scheduleAutoClear = () => {
        if (timerRef.current) clearTimeout(timerRef.current);
        timerRef.current = setTimeout(() => {
            textsRef.current = [];
        }, AUTO_CLEAR_MS);
    };

    // options.reset (Ctrl held): drop the history and keep only this value.
    const addText = (text, options = {}) => {
        const { reset = false } = options;
        const value = String(text ?? '');

        const prev = textsRef.current;
        let texts;
        if (reset) {
            texts = [value];
        } else if (prev.includes(value)) {
            texts = prev; // already there → don't add the same value again
        } else {
            texts = [...prev, value];
        }

        textsRef.current = texts;

        // Kopyalama ve bildirim bilinçli olarak senkron akışın dışında; copyToClipboard fırlatmaz.
        copyToClipboard(texts.join('\n'), {
            successMessage: t('Copied to clipboard'),
            description: `${texts.length} ${t('texts copied')}`
        });

        scheduleAutoClear();
    };

    useEffect(() => () => {
        if (timerRef.current) clearTimeout(timerRef.current);
    }, []);

    return (
        <ClipboardContext.Provider value={{ addText }}>
            {children}
        </ClipboardContext.Provider>
    );
};
